require("rangeslider.js");
// require("slick-carousel");
require("jquery-inview");
require("select2")(jQuery);

const bodyScrollLock = require("body-scroll-lock");
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;

window.mobileAndTabletCheck = function () {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true;
  })(navigator.userAgent || navigator.vendor || window.opera);
  return check;
};

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
};

(function ($) {
  $(function () {
    // Mobile menu handling
    const mobileMenuToggle = $(".mobile-menu-toggle");
    const mainNav = $(".main-nav");
    const body = $("body");

    mobileMenuToggle.on("click", function () {
      $(this).toggleClass("active");
      mainNav.toggleClass("active");

      if (mainNav.hasClass("active")) {
        disableBodyScroll(mainNav[0]);
      } else {
        enableBodyScroll(mainNav[0]);
      }
    });

    // Close mobile menu on link click
    // $(".main-nav .nav-list a").on("click", function () {
    //   if (mainNav.hasClass("active")) {
    //     mobileMenuToggle.removeClass("active");
    //     mainNav.removeClass("active");
    //     enableBodyScroll(mainNav[0]);
    //   }
    // });

    // Close mobile menu on window resize if open
    $(window).on("resize", function () {
      if (window.innerWidth > 768 && mainNav.hasClass("active")) {
        mobileMenuToggle.removeClass("active");
        mainNav.removeClass("active");
        enableBodyScroll(mainNav[0]);
      }
    });

    $(".event-card-link").on("click", function (event) {
      event.preventDefault();
      const targetEvent = $(this).data("event");
      const targetCheckbox = $("#" + targetEvent);
      const targetButton = $("button[data-target='" + targetEvent + "']");

      // Scroll to the #iscriviti anchor
      $("html, body").animate(
        {
          scrollTop: $("#iscriviti").offset().top,
        },
        1000
      );

      // Set the relative checkbox to checked
      targetCheckbox.prop("checked", true);

      // Add active class to the relative custom-button
      targetButton.addClass("active");
    });

    $(".event-video-trigger").on("click", function () {
      const targetEvent = $(this).data("event");
      const videoUrl = $(this).data("video");
      const modal = $(".video-modal");
      const video = modal.find(".video-modal__video iframe");
      video.attr(
        "src",
        "https://www.youtube.com/embed/" + videoUrl + "?autoplay=1"
      );
      modal.addClass("active");
      $(".video-overlay").addClass("active");
    });

    $(".video-modal__close").on("click", function () {
      $(".video-modal").removeClass("active");
      $(".video-overlay").removeClass("active");
      $(".video-modal__video iframe").attr("src", "");
    });

    $(".video-overlay").on("click", function () {
      $(".video-modal").removeClass("active");
      $(".video-overlay").removeClass("active");
      $(".video-modal__video iframe").attr("src", "");
    });

    // FORM
    document.querySelectorAll(".custom-button").forEach((button) => {
      button.addEventListener("click", function () {
        const targetCheckbox = document.getElementById(this.dataset.target);
        targetCheckbox.checked = !targetCheckbox.checked;
        this.classList.toggle("active", targetCheckbox.checked);
        const anyActiveButton = document.querySelector(".custom-button.active");
        if (!anyActiveButton) {
          document
            .querySelector(".mentorship-events-selection")
            .classList.add("error");
        } else {
          document
            .querySelector(".mentorship-events-selection")
            .classList.remove("error");
        }
        const activeButtons = document.querySelectorAll(
          ".custom-button.active"
        ).length;
        if (activeButtons > 1) {
          const selectedEvents = Array.from(
            document.querySelectorAll(".custom-button.active")
          ).map((button) => button.dataset.event);

          const label = document.getElementById("priorita_field_label");
          label.classList.add("active");
          for (let i = 1; i <= 4; i++) {
            const field = document.getElementById(`priorita_field_${i}`);
            if (i <= activeButtons) {
              field.classList.add("active");
            } else {
              field.classList.remove("active");
            }
            const select = document.getElementById(`priorita_${i}`);
            // Hide options not present in selectedEvents except the option with data-placeholder="true"
            const options = select.options;
            for (let j = 0; j < options.length; j++) {
              if (
                !selectedEvents.includes(options[j].value) &&
                !options[j].dataset.placeholder
              ) {
                options[j].style.display = "none";
                options[j].style.visibility = "hidden";
                options[j].setAttribute("aria-hidden", "true");
                options[j].disabled = true;
                options[j].setAttribute("hidden", "true");
              } else {
                options[j].style.display = "block";
                options[j].style.visibility = "visible";
                options[j].setAttribute("aria-hidden", "false");
                options[j].disabled = false;
                options[j].removeAttribute("hidden");
              }
            }
          }
        } else {
          const label = document.getElementById("priorita_field_label");
          label.classList.remove("active");
        }
      });
    });

    document
      .querySelectorAll("#priorita_1, #priorita_2, #priorita_3, #priorita_4")
      .forEach((select) => {
        select.addEventListener("change", function () {
          const selectedValues = Array.from(
            document.querySelectorAll(
              "#priorita_1, #priorita_2, #priorita_3, #priorita_4"
            )
          )
            .map((select) => select.value)
            .filter((value) => value !== "");

          document
            .querySelectorAll(
              "#priorita_1, #priorita_2, #priorita_3, #priorita_4"
            )
            .forEach((select) => {
              Array.from(select.options)
                .filter((option) => option.hidden !== true)
                .forEach((option) => {
                  if (
                    selectedValues.includes(option.value) &&
                    option.value !== select.value
                  ) {
                    option.disabled = true;
                  } else {
                    option.disabled = false;
                  }
                });
            });
        });
      });

    $(".registration-form form").on("submit", function (event) {
      event.preventDefault();

      if (
        !$("#event1").is(":checked") &&
        !$("#event2").is(":checked") &&
        !$("#event3").is(":checked") &&
        !$("#event4").is(":checked")
      ) {
        $("#error").html("Please select at least one event.").show();
        $(".mentorship-events-selection").addClass("error");

        return;
      }

      var postObject = {
        firstname: $("#firstname").val(),
        lastname: $("#lastname").val(),
        email: $("#email").val(),
        phone: $("#phone").val(),
        ente: $("#ente").val(),
        tipo_ente: $("#tipo_ente").val(),
        numero_dipendenti: $("#numero_dipendenti").val(),
        fatturato: $("#fatturato").val(),
        settore_attivita: $("#settore_attivita").val(),
        event1: $("#event1").is(":checked") == true ? "true" : "false",
        event2: $("#event2").is(":checked") == true ? "true" : "false",
        event3: $("#event3").is(":checked") == true ? "true" : "false",
        event4: $("#event4").is(":checked") == true ? "true" : "false",
        priorita_1: $("#priorita_1").val(),
        priorita_2: $("#priorita_2").val(),
        priorita_3: $("#priorita_3").val(),
        priorita_4: $("#priorita_4").val(),
        motivation: $("#motivation").val(),
        privacy: $("#privacy").is(":checked") == true ? "true" : "false",
      };
      //console.log(postObject);
      var saveUrl = $(".registration-form form").attr("data-action");

      $.ajax({
        url: saveUrl,
        type: "POST",
        data: postObject,
        beforeSend: function (xhr) {
          // $('#form_invia input[type="submit"]').css("display", "none");

          $(".loading").css("display", "block");
          $("#error").hide();
          $("#result").hide();
          $(".registration-form form button").addClass("disabled");
        },
        success: function (data) {
          // console.log(data);
          if (parseInt(data) == 1) {
            // console.log("successo!");
            $("#result").show();
            $(".registration-form form button").removeClass("disabled");
            $(".registration-form form input").val("");
            $(".registration-form form select").val("");
            $(".registration-form form textarea").val("");
            $(".registration-form form input[type='checkbox']").prop(
              "checked",
              false
            );
            $(".custom-button").removeClass("active");
            $(".loading").css("display", "none");
            $("#priorita_field_label").removeClass("active");
            $("#priorita_field_1").removeClass("active");
            $("#priorita_field_2").removeClass("active");
            $("#priorita_field_3").removeClass("active");
            $("#priorita_field_4").removeClass("active");
          } else {
            $("#error").html(data).show();
            console.log(data);
          }
        },
        error: function (xhr, status, error) {
          console.log(error);
          $("#error").html(error).show();
          $(".loading").css("display", "none");
          // $(".form-error").css("display", "block");
        },
      });
    });

    // $("input, textarea, select")
    //   .keydown(function (e) {
    //     if (e.which == 38 || e.which == 40) {
    //       scrollLocomotive.stop();
    //     }
    //   })
    //   .keyup(function (e) {
    //     scrollLocomotive.start();
    //   });
    // $(document).keydown(function (e) {
    //   var keyCode = e.keyCode || e.which;

    //   // tab, space
    //   if (keyCode == 9) {
    //     e.preventDefault();
    //     return false;
    //   }
    // });

    /*
    $(".kit form").on("submit", function (event) {
      event.preventDefault();
      var form = $(".kit form");
      var postData = {
        name: form.find("#name").val(),
        email: form.find("#email").val(),
        message: form.find("#message").val(),
        privacy: form.find("#privacy").val(),
      };
      $.ajax({
        url: "sendmail.php",
        type: "POST",
        data: postData,
        success: function (data) {
          console.log(data);
          if (data == 1) {
            // form.find("#name").val("");
            // form.find("#email").val("");
            // form.find("#message").val("");
            // form.find("#privacy").prop("checked", false);
            // form.find("#output").show();
            window.location.replace("thankyou.php");
          }
        },
        error: function (xhr, status, error) {
          console.log(error);
        },
      });
    }); */
  });
})(jQuery);
